import { useQuery } from "@tanstack/react-query";
import * as URLUtils from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
const functionsUrl = URLUtils.qualifyUrl("/views/functions");
const fetchAggregationFunctions = () => fetch("GET", functionsUrl);
const useAggregationFunctions = () => useQuery({
  queryKey: ["aggregationFunctions"],
  queryFn: fetchAggregationFunctions
});
export default useAggregationFunctions;
